import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { Button } from '../ui/Button';
import { motion } from 'framer-motion';
export function Authority() {
  const {
    t
  } = useLanguage();
  const stats = t('authority.stats');
  const pillars = t('authority.pillars');
  const easeOutCubic = [0.33, 1, 0.68, 1];
  const scrollToContact = () => {
    document.getElementById('contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 lg:py-28 bg-brand-dark text-brand-cream relative overflow-hidden" data-id="element-27">
      {/* Subtle grain */}
      <div className="absolute inset-0 bg-grain opacity-50 pointer-events-none" data-id="element-28"></div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-29">
        <div className="text-center max-w-2xl mx-auto mb-14" data-id="element-30">
          <span className="text-brand-gold/80 font-medium tracking-[0.25em] text-xs uppercase mb-6 block" data-id="element-31">
            {t('authority.eyebrow')}
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light mb-6 tracking-tight" data-id="element-32">
            {t('authority.heading')}
          </h2>
          <div className="w-12 h-px bg-brand-gold mx-auto mt-10" data-id="element-33"></div>
        </div>

        {/* Stats row */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.9,
        ease: easeOutCubic
      }} className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12 max-w-5xl mx-auto mb-16 pb-14 border-b border-brand-cream/10" data-id="element-34">
          {stats.map((stat: any, idx: number) => <div key={idx} className="text-center" data-id="element-35">
              <p className="font-serif text-5xl lg:text-6xl text-brand-cream font-light mb-3" data-id="element-36">
                {stat.value}
              </p>
              <p className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/50" data-id="element-37">
                {stat.label}
              </p>
            </div>)}
        </motion.div>

        {/* Pillars grid */}
        <div className="grid md:grid-cols-2 gap-10 lg:gap-14 max-w-5xl mx-auto mb-16" data-id="element-38">
          {pillars.map((pillar: any, idx: number) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.8,
          delay: idx * 0.15,
          ease: easeOutCubic
        }} className="flex gap-6" data-id="element-39">
              <span className="font-serif text-2xl text-brand-gold/80 font-light italic shrink-0" data-id="element-40">
                0{idx + 1}
              </span>
              <div data-id="element-41">
                <h3 className="font-serif text-2xl text-brand-cream font-light mb-3" data-id="element-42">
                  {pillar.title}
                </h3>
                <p className="text-brand-cream/60 font-light leading-relaxed" data-id="element-43">
                  {pillar.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* Financing row */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.9,
        ease: easeOutCubic
      }} className="text-center max-w-3xl mx-auto pt-14 border-t border-brand-cream/10" data-id="element-44">
          <p className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/40 mb-6" data-id="element-45">
            {t('authority.financingTitle')}
          </p>
          <p className="font-serif text-xl lg:text-2xl text-brand-cream/80 font-light leading-relaxed mb-12 max-w-xl mx-auto" data-id="element-46">
            {t('authority.financingNote')}
          </p>

          <div className="mt-16" data-id="element-47">
            <Button variant="luxury" size="lg" onClick={scrollToContact} className="border-brand-cream/30 text-brand-cream hover:bg-brand-cream hover:text-brand-dark" data-id="element-48">
              {t('nav.cta')}
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}